<template>
        <div 
            v-if="thumbnail != ''"
            class="user_thumbnail-wrapper"
            :class="`bg-${userStatusBgColor}`"
        >
            <div
                class="user_thumbnail"
                :class="userStatusBgColor != 'primary' ? 'user_thumbnail-transparent' : ''"
                :style="{backgroundImage: `url(${encodeURI(thumbnail)}`}"
            ></div>
        </div>
        <user-status-icon 
            v-else
            :bgColor="userStatusBgColor"
            :isAvatar="true"
        ></user-status-icon>
</template>

<script>
import UserStatusIconVue from './UserStatusIcon.vue'
export default {    
    name: 'user-thumbnail',
    components: {
        'user-status-icon': UserStatusIconVue
    },
    props: {
        thumbnail: {
            type: String,
            default: ''
        },
        userStatusBgColor: {
            type: String,
            default: 'primary'
        }
    }
}
</script>

<style lang="scss">
    .user_thumbnail {
        background-repeat: no-repeat;
        background-size: cover;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-position: center center;

        &-transparent {
            opacity: .6;
        }

        &-wrapper {
            position: relative;
            border-radius: 50%;
        }
    }

    .user-list-view {
        .user_thumbnail {
            width: 90px;
            height: 90px;
        }
    }
</style>